import {User} from 'common/report/queries/query-api/types';
import {FormattedProperty} from 'common/util/format-property';
import {DateRangeAttributes} from 'common/widgets/date-range-picker/models/date-range';

export const DEFAULT_USER_NAME = `User Profile`;

export enum ProfileQueryEndpoint {
  Aliases = `aliases`,
  Engage = `engage`,
  Messages = `messages`,
}

export interface ProfileQueryParameters {
  projectId: string;
  workspaceId: string;

  dataGroupID?: string;
  distinctID?: string;

  // Activity stream requires a to-from date w/ list of ids
  dateRange?: DateRangeAttributes;
  limit?: number;
  toDate?: string;
  fromDate?: string;
  distinctIDs?: string[];
  excludeEvents?: string[];
  includeEvents?: string[];
}

export interface EngageQueryResult {
  error?: string;
  results?: {
    results: {
      results: User[];
    };
    status: string;
  };
  cached: boolean;
}

export interface AliasesQueryResult {
  error?: string;
  results?: {
    aliases: string[];
    resolves_to: string;
    status: string;
  };
  cached: boolean;
}

export interface FormattedEngageResult {
  error: boolean;
  readonly results: Map<string, FormattedProperty>;
  messages: string[];
  readonly profileExists: boolean;
}

export enum MessageMediaType {
  Email = `email`,
  Push = `push`,
}

export interface MessagesResultItem {
  date: string;
  body: string;
  messageMedia: MessageMediaType;
  id: number;
  subject: string;
}

export interface FormattedMessagesResult {
  error: boolean;
  results: MessagesResultItem[];
}

export interface FormattedAliasesResult {
  aliases: string[];
  error: boolean;
  resolvesTo: string;
}

export const REPORT_NAME = `User Profile`;

export enum UserDemographicsTab {
  MessagesTab = `Messages`,
  PropertiesTab = `Properties`,
}

// Raw api results
export interface UnformattedUserEvent {
  event: string;
  properties: {[name: string]: any};
}
